"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _immer = _interopRequireDefault(require("immer"));

var _lodash = require("lodash");

var _GeneralSettings = _interopRequireDefault(require("../components/settings/GeneralSettings"));

var _DeploymentSettings = _interopRequireDefault(require("../components/settings/DeploymentSettings"));

var _SyncSettings = _interopRequireDefault(require("../components/settings/SyncSettings"));

var _ApiSettings = _interopRequireDefault(require("../components/settings/ApiSettings"));

var _EditorSettings = _interopRequireDefault(require("../components/settings/EditorSettings"));

var _LanguageSettings = _interopRequireDefault(require("../components/settings/LanguageSettings"));

var _CmsLayout = _interopRequireDefault(require("../components/CmsLayout"));

var _redux = require("../redux"); // import app components


var Settings = function Settings(props) {
  var fields = props.fields;

  var _ref = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      _ref$cms = _ref.cms,
      site = _ref$cms.site,
      siteLoaded = _ref$cms.siteLoaded,
      editorSite = _ref$cms.editor.site;

  var dispatch = (0, _redux.useAppDispatch)();

  var _ref2 = (0, _react.useState)('general'),
      _ref3 = _slicedToArray(_ref2, 2),
      tab = _ref3[0],
      setTab = _ref3[1];

  var _ref4 = (0, _react.useState)(null),
      _ref5 = _slicedToArray(_ref4, 2),
      loading = _ref5[0],
      setLoading = _ref5[1];

  (0, _react.useEffect)(function () {
    siteLoaded && dispatch(_redux.cmsActions.addEditorSite(site));
  }, [siteLoaded, tab]);

  var handleChange = function handleChange(name, value) {
    var nextSite = (0, _immer.default)(editorSite, function (draft) {
      return (0, _lodash.set)(draft, name, value);
    });
    dispatch(_redux.cmsActions.updateEditorSite(nextSite));
  };

  var handleUpdate = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args, loader) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(loader);
              _context.next = 3;
              return dispatch(_redux.siteActions.updateSite(args));

            case 3:
              setLoading(null);

              _antd.message.success('Updated successfully');

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleUpdate(_x, _x2) {
      return _ref6.apply(this, arguments);
    };
  }();

  var tabs = ['general', 'deployment', 'syncing', 'api', 'editor'];

  if (!!(editorSite !== null && editorSite !== void 0 && editorSite.languages)) {
    tabs.push('languages');
  }

  return /*#__PURE__*/_react.default.createElement(_CmsLayout.default, {
    fields: fields,
    pageTitle: "Settings"
  }, /*#__PURE__*/_react.default.createElement(_antd.Tabs, {
    defaultActiveKey: "all",
    onChange: function onChange(v) {
      return setTab(v);
    }
  }, tabs.map(function (name) {
    return /*#__PURE__*/_react.default.createElement(_antd.Tabs.TabPane, {
      key: name,
      tab: name.toUpperCase(),
      disabled: !site
    });
  })), tab === 'general' && /*#__PURE__*/_react.default.createElement(_GeneralSettings.default, {
    onChange: handleChange,
    onUpdate: handleUpdate,
    loading: loading
  }), tab === 'deployment' && /*#__PURE__*/_react.default.createElement(_DeploymentSettings.default, {
    onChange: handleChange,
    onUpdate: handleUpdate,
    loading: loading
  }), tab === 'syncing' && /*#__PURE__*/_react.default.createElement(_SyncSettings.default, {
    onUpdate: handleUpdate,
    loading: loading
  }), tab === 'api' && /*#__PURE__*/_react.default.createElement(_ApiSettings.default, {
    onChange: handleChange,
    onUpdate: handleUpdate,
    loading: loading
  }), tab === 'editor' && /*#__PURE__*/_react.default.createElement(_EditorSettings.default, {
    onChange: handleChange,
    onUpdate: handleUpdate,
    loading: loading
  }), tab === 'languages' && /*#__PURE__*/_react.default.createElement(_LanguageSettings.default, {
    fields: fields
  }));
};

var _default = Settings;
exports.default = _default;